module.exports = __webpack_public_path__ + "static/media/Cart.3a09f90a.png";